import { Flex as FlexBase, Select as SelectBase } from '@chakra-ui/react';
import { rotuloDaEmpresa, rotuloDaFilial, useAssistente } from '../../context/AssistenteContext';
import { tabelaRegioes } from '../../helpers/regioes';

// Cast Chakra components to bypass TS2590 ("union type too complex").
const Flex = FlexBase as React.ComponentType<any>;
const Select = SelectBase as React.ComponentType<any>;

const ESTILO = {
  variant: 'filled',
  bg: 'gray.700',
  color: 'gray.50',
  borderRadius: '8px',
  _hover: { bg: 'gray.600' },
  _focus: { bg: 'gray.700', boxShadow: 'none' },
};

// O que o assistente consulta: a empresa (todas as filiais dela, somadas) e,
// se quiser, uma filial e uma região do cliente, para descer ao detalhe. As
// regiões são as da tabela do Mapa Cirúrgico (helpers/regioes.ts). A mesma escolha no painel e no
// chat, no balão e na página (mora no AssistenteContext). Voltar para "Escolha
// a empresa" tira a escolha, e o painel volta a pedir uma.
export function SeletorDeFilial({ size = 'sm', ...props }: Record<string, any>) {
  const {
    empresas,
    empresaCodigo,
    escolherEmpresa,
    filialId,
    escolherFilial,
    regiao,
    escolherRegiao,
    carregandoFiliais,
  } = useAssistente();
  const empresa = empresas.find((e) => e.codigo === empresaCodigo);
  return (
    <Flex align="center" minW={0} sx={{ gap: '8px' }} {...props}>
      <Select
        aria-label="Empresa"
        size={size}
        {...ESTILO}
        value={empresaCodigo}
        placeholder={
          carregandoFiliais && !empresas.length ? 'Carregando empresas…' : 'Escolha a empresa'
        }
        onChange={(e: any) => escolherEmpresa(e.target.value)}
      >
        {empresas.map((e) => (
          <option key={e.codigo} value={e.codigo}>
            {rotuloDaEmpresa(e)}
          </option>
        ))}
      </Select>
      {empresa && empresa.filiais.length > 1 && (
        <Select
          aria-label="Filial"
          size={size}
          {...ESTILO}
          value={filialId}
          onChange={(e: any) => escolherFilial(e.target.value)}
        >
          <option value="">Todas as filiais</option>
          {empresa.filiais.map((f) => (
            <option key={f.id} value={f.id}>
              {rotuloDaFilial(f)}
            </option>
          ))}
        </Select>
      )}
      {empresa && (
        <Select
          aria-label="Região"
          size={size}
          {...ESTILO}
          value={regiao}
          onChange={(e: any) => escolherRegiao(e.target.value)}
        >
          <option value="">Todas as regiões</option>
          {Object.entries(tabelaRegioes(empresa.codigo)).map(([codigo, nome]) => (
            <option key={codigo} value={codigo}>
              {`${codigo} · ${nome}`}
            </option>
          ))}
        </Select>
      )}
    </Flex>
  );
}
